<template lang="pug">
div
    BaseHeader(
        :titulo='titulo',
        icon='mdi mdi-file-plus',
        :exibeBotao='false',
        voltarPara='emit',
        @voltarClicado='goToCertificacoes()'
    )
    .view-container
        #container
            h2 Situação do território
            .info-area(:class='isCollapsed ? "gap-0" : "gap-20"')
                .info-area-lista-diagnosticos
                    .infos
                        .info-area__titulo-territorio
                            h2 Território
                            span
                            el-tooltip(
                                :content='isCollapsed ? "Expandir diagnósticos" : "Recuar diagnósticos"',
                                placement='top'
                            )
                                i(
                                    @click='toggleCollapse',
                                    :class='isCollapsed ? "el-icon-arrow-right" : "el-icon-arrow-left"'
                                )
                        div(
                            v-for='(diagnosticoGeometria, index) in diagnosticosSocioambientaisCertificacao.resultadosGeometrias'
                        )
                            AccordionDiagnosticosSocioambientaisCertificacao(
                                :diagnostico='diagnosticoGeometria',
                                tipoDiagnostico='geometria',
                                :indexDiagnostico='index',
                                @addLayersRestricao='addLayersRestricao',
                                @removeLayers='removeLayers',
                                @updateOpacidade='updateOpacidade',
                                @addLayersGeometria='addLayersGeometria',
                                :mapaLeaflet='refMapa',
                                :collapsed='isCollapsed'
                            )
                        div(v-if='!possuiDiagnosticosGeometrias()')
                            p Não foram gerados resultados vinculados às geometrias deste território
                    .infos
                        h2 CAR's
                        div(
                            v-for='(diagnosticoCar, index) in diagnosticosSocioambientaisCertificacao.resultadosCars'
                        )
                            AccordionDiagnosticosSocioambientaisCertificacao(
                                :diagnostico='diagnosticoCar',
                                tipoDiagnostico='car',
                                :indexDiagnostico='index',
                                @addLayersRestricao='addLayersRestricao',
                                @removeLayers='removeLayers',
                                @updateOpacidade='updateOpacidade',
                                @addLayersGeometria='addLayersGeometria',
                                :mapaLeaflet='refMapa',
                                :collapsed='isCollapsed'
                            )
                        div(v-if='!possuiDiagnosticosCars()')
                            p Não foram gerados resultados vinculados os CAR deste território
                    .infos
                        h2 Representantes
                        div(
                            v-for='(diagnosticoRepresentante, index) in diagnosticosSocioambientaisCertificacao.resultadosRepresentantes'
                        )
                            AccordionDiagnosticosSocioambientaisCertificacao(
                                :diagnostico='diagnosticoRepresentante',
                                tipoDiagnostico='representante',
                                :indexDiagnostico='index',
                                @addLayersRestricao='addLayersRestricao',
                                @removeLayers='removeLayers',
                                @updateOpacidade='updateOpacidade',
                                @addLayersGeometria='addLayersGeometria',
                                :mapaLeaflet='refMapa',
                                :collapsed='isCollapsed'
                            )
                        div(v-if='!possuiDiagnosticosRepresentantes()')
                            p Não foram gerados resultados vinculados aos representantes deste território
                .info-area-mapa(:class='isCollapsed ? "flex-4" : "flex-1"')
                    .mapa
                        mapa(
                            ref='mapa',
                            :showStatesLayers='false',
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :height='"100%"',
                            :idMapa='"mapaDiagnosticoSocioambientalCertificacao"',
                            :atualizarMapa='true'
                        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import certificacaoService from '@/services/CertificacaoService.js';
import { TIPOS_CERTIFICACAO } from '@/utils/tipoCertificacao.js';
import Mapa from '@/components/MapaLeaflet.vue';
import AccordionDiagnosticosSocioambientaisCertificacao from '@/components/certificacao/AccordionDiagnosticosSocioambientaisCertificacao.vue';
import formatter from '@/utils/formatters.js';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

const YELLOW = 'yellow';
const LIGHT_GREEN = '#00FF00';
const TIPO_GEOMETRIA = {
    TERRITORIO: 'TERRITORIO',
    AREA_PLANTADA: 'AREA_PLANTADA'
};

export default {
    name: 'DetalhamentoResultadosDiagnosticos',

    components: {
        BaseHeader,
        Mapa,
        AccordionDiagnosticosSocioambientaisCertificacao
    },

    data() {
        return {
            titulo: '',
            diagnosticosSocioambientaisCertificacao: {},
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: true,
                diagnostico: true
            },
            indexCollapseAgrupado: '',
            indexCollapseResultado: '',
            point: 'Point',
            refMapa: null,
            isCollapsed: false,
            idCertificacaoTerritorio: 0,
            idCertificacaoTerritorioTipo: 0
        };
    },

    mounted() {
        this.buscarResultadosDiagnosticos();
        this.setTitulo();
        this.refMapa = this.$refs['mapa'];
    },

    methods: {
        async buscarResultadosDiagnosticos() {
            this.idCertificacaoTerritorio =
                this.$route.params.idCertificacaoTerritorio;
            this.idCertificacaoTerritorioTipo =
                this.$route.params.idCertificacaoTerritorioTipo;
            const { data } =
                await certificacaoService.buscarResultadoDiagnosticoAnaliseCertificacao(
                    this.idCertificacaoTerritorio,
                    this.idCertificacaoTerritorioTipo
                );
            this.diagnosticosSocioambientaisCertificacao = data;
            this.setOpacidadeDiagnosticos();
        },

        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
            setTimeout(() => this.$refs.mapa.refreshMap(), 300);
        },

        setOpacidadeDiagnosticos() {
            this.diagnosticosSocioambientaisCertificacao.resultadosGeometrias.forEach(
                resultadoGeometria => {
                    resultadoGeometria.resultadoDiagnostico.forEach(r => {
                        r.opacidade = 100;
                    });
                }
            );

            this.diagnosticosSocioambientaisCertificacao.resultadosRepresentantes.forEach(
                resultadoRepresentante => {
                    resultadoRepresentante.resultadoDiagnostico.forEach(r => {
                        r.opacidade = 100;
                    });
                }
            );

            this.diagnosticosSocioambientaisCertificacao.resultadosCars.forEach(
                resultadoCar => {
                    resultadoCar.resultadoDiagnostico.forEach(d => {
                        d.opacidade = 100;
                    });
                }
            );
        },

        setTitulo() {
            if (this.idCertificacaoTerritorioTipo) {
                const nomeCertificacao = this.getNomeCertificacaoById(
                    this.idCertificacaoTerritorioTipo
                );
                const recorte = this.getRecorte();

                this.titulo = `Certificação ${nomeCertificacao} ${
                    recorte || ''
                }`;
            }
        },

        getRecorte() {
            if (
                this.idCertificacaoTerritorioTipo ===
                    TIPOS_CERTIFICACAO._2BSVS.id &&
                this.$route.params?.possuiResultadoParcial
            ) {
                return this.$route.params?.isRecorteElegivel
                    ? ' - Recorte parcialmente elegível'
                    : ' - Recorte inelegível';
            }
            return null;
        },

        getNomeCertificacaoById(idTipoCertificacao) {
            idTipoCertificacao = parseInt(idTipoCertificacao);
            if (idTipoCertificacao) {
                switch (idTipoCertificacao) {
                    case TIPOS_CERTIFICACAO._2BSVS.id:
                        return TIPOS_CERTIFICACAO._2BSVS.nome;
                    case TIPOS_CERTIFICACAO.PROTERRA.id:
                        return TIPOS_CERTIFICACAO.PROTERRA.nome;
                    case TIPOS_CERTIFICACAO.RTRS.id:
                        return TIPOS_CERTIFICACAO.RTRS.nome;
                    case TIPOS_CERTIFICACAO.EPA.id:
                        return TIPOS_CERTIFICACAO.EPA.nome;
                    case TIPOS_CERTIFICACAO.EUDR.id:
                        return TIPOS_CERTIFICACAO.EUDR.nome;
                }
            }
        },

        possuiDiagnosticosGeometrias() {
            return (
                this.diagnosticosSocioambientaisCertificacao
                    .resultadosGeometrias &&
                this.diagnosticosSocioambientaisCertificacao
                    .resultadosGeometrias.length > 0
            );
        },

        possuiDiagnosticosCars() {
            return (
                this.diagnosticosSocioambientaisCertificacao.resultadosCars &&
                this.diagnosticosSocioambientaisCertificacao.resultadosCars
                    .length > 0
            );
        },

        possuiDiagnosticosRepresentantes() {
            return (
                this.diagnosticosSocioambientaisCertificacao
                    .resultadosRepresentantes &&
                this.diagnosticosSocioambientaisCertificacao
                    .resultadosRepresentantes.length > 0
            );
        },

        formatArea(value, decimalPlaces = 2) {
            return formatter.maxFormatNumber(value, decimalPlaces);
        },

        goToCertificacoes() {
            this.$router.push({
                name: 'VisualizarAnalise',
                params: {
                    idCertificacao: this.$route.params.idRouteParaCertificacoes
                }
            });
        },

        addLayersRestricao(resultadosComRestricoes, nomeGrupoResultados) {
            if (resultadosComRestricoes?.length > 0) {
                resultadosComRestricoes.forEach(r => {
                    const layer = this.getObjectLayerRestricao(
                        r,
                        nomeGrupoResultados
                    );

                    if (layer) {
                        this.layersMaps.push(layer);
                    }
                });
            }
        },

        removeLayers(nomeGrupoRemovido) {
            const updatedLayersMaps = this.layersMaps.filter(
                l =>
                    l.grupo !== nomeGrupoRemovido &&
                    l.grupo !== nomeGrupoRemovido + '-area-plantada'
            );
            this.layersMaps = updatedLayersMaps;
        },

        getObjectLayerRestricao(resultado, nomeGrupoResultados) {
            let geometria =
                resultado.geometry ||
                resultado.geometria ||
                resultado.properties?.geometry ||
                resultado.properties?.geometria ||
                resultado.propriedade?.geometry ||
                resultado.propriedade?.geometria;

            if (
                !geometria &&
                resultado.properties?.latitude &&
                resultado.properties?.longitude
            ) {
                geometria = {
                    type: this.point,
                    coordinates: [
                        resultado.properties.longitude,
                        resultado.properties.latitude
                    ]
                };
            }

            if (geometria) {
                const isPonto = this.isPonto(geometria);

                const pin = L.icon({
                    iconUrl:
                        'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                const style = {
                    color: 'red',
                    weight: 1,
                    fill: true,
                    opacity: 100 / 200,
                    fillOpacity: 100 / 200
                };

                return {
                    name: 'centroid' + Math.random(),
                    grupo: nomeGrupoResultados,
                    geoJson: isPonto
                        ? centroidFromGeoJSON.get(geometria)
                        : geometria,
                    icon: isPonto ? pin : null,
                    style: !isPonto ? style : null
                };
            }

            return null;
        },

        isPonto(geometria) {
            return geometria?.type?.toUpperCase() === this.point.toUpperCase();
        },

        updateOpacidade(nomeGrupoNovaOpacidade, opacidade) {
            const copiaLayersMaps = this.layersMaps;
            const novaOpacidade = opacidade / 200;

            copiaLayersMaps.forEach(layer => {
                if (layer.grupo === nomeGrupoNovaOpacidade) {
                    layer.style.fillOpacity = novaOpacidade;
                    layer.style.opacity = novaOpacidade;
                }
            });

            this.layersMaps = copiaLayersMaps;
        },
        addLayersGeometria(
            geometria,
            geometriaAreaPlantada,
            nomeGrupoGeometria,
            nomeGrupoAreaPlantada
        ) {
            if (!geometria || !nomeGrupoGeometria) {
                return;
            }

            const createStyle = tipoGeometria => {
                return {
                    color:
                        tipoGeometria === TIPO_GEOMETRIA.TERRITORIO
                            ? LIGHT_GREEN
                            : YELLOW,
                    weight: 2,
                    fill: tipoGeometria === TIPO_GEOMETRIA.AREA_PLANTADA,
                    opacity: 0.5,
                    fillOpacity: 0.5
                };
            };

            const generateRandomName = () => {
                return 'centroid' + Math.random();
            };

            const processGeometry = (geo, tipoGeometria, nomegrupo) => {
                this.layersMaps.push({
                    name: generateRandomName(),
                    grupo: nomegrupo,
                    geoJson: geo,
                    style: createStyle(tipoGeometria)
                });
            };

            processGeometry(
                geometria,
                TIPO_GEOMETRIA.TERRITORIO,
                nomeGrupoGeometria
            );
            if (geometriaAreaPlantada) {
                processGeometry(
                    geometriaAreaPlantada,
                    TIPO_GEOMETRIA.AREA_PLANTADA,
                    nomeGrupoAreaPlantada
                );
            }
        }
    },

    watch: {
        indexCollapseResultado: function () {
            this.$emit('index-aberto', this.indexCollapseResultado);
        }
    }
};
</script>

<style lang="scss">
#container {
    padding: 20px 0;
}

.info-area {
    height: 560px;
    display: flex;
    margin-top: 5px;
}

.info-area-lista-diagnosticos {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    height: 560px;
    overflow-y: scroll;
    background-color: var(--white);
    padding: 15px;
    border-radius: $default-border-radius;
}

.info-area-mapa {
    height: inherit;
    transition: flex 0.3s ease;
}

.mapa {
    height: 100%;
    border-radius: $default-border-radius;
}

h2 {
    width: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-area__titulo-territorio {
    display: flex;
    justify-content: space-between;
}

.flex-4 {
    flex: 4;
}

.flex-1 {
    flex: 1;
}

.gap-20 {
    gap: 20px;
}

.gap-0 {
    gap: 0;
}
</style>
